export function getMachineCurrentLocationName(machine, expectedLocalType) {
  if (
    Number(machine?.CurrentLocalMachineCount) !== 1 ||
    machine?.CurrentLocalType !== expectedLocalType
  ) {
    return "—";
  }

  return machine?.CurrentLocalName || "—";
}
